<template>
    <a-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <a-spin :spinning="confirmLoading">
        <a-card style="" :bordered="true" :title="$t('数据详情')">
            <detail-list :col="2" v-if="!!model.meterIdList">
              <a-textarea v-model="model.meterIdList" placeholder="..." :rows="3" style="width:100%;" disabled />
            </detail-list>
            <detail-list :col="2" v-else>
              <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
              <detail-list-item :term="$t('表类型')">{{model.meterType?$t(meterTypeObj[model.meterType]):model.meterType}}</detail-list-item>
              <detail-list-item :term="$t('软件版本号')">{{model.meterSoftVersion}}</detail-list-item>
              <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr?model.userMeterAddr: '--'}}</detail-list-item>
              <detail-list-item :term="$t('运营商')">{{model.meterIotType?$t(netTypeObj[model.meterIotType]):model.meterIotType}}</detail-list-item>
              <detail-list-item :term="$t('失联天数')">{{model.lostContactDay}}</detail-list-item>
              <detail-list-item :term="$t('失联时间')">{{model.updateTime}}</detail-list-item>
            </detail-list>
            
        </a-card>
        <a-form-model ref="formModal" :model="formModel" :rules="rules" :colon="false">
            <a-row :gutter="48">
                <a-col :span="7">
                </a-col>
                <a-col :span="8">
                    <a-form-item :label="$t('处理状态')" prop="meterDealStatus">
                        <a-select v-model="formModel.meterDealStatus" :placeholder="$t('请选择处理状态')" type="primary">
                            <a-select-option :value="0">
                                {{ $t('未处理') }}
                            </a-select-option>
                            <a-select-option :value="1">
                                {{ $t('处理中') }}
                            </a-select-option>
                            <a-select-option :value="2">
                                {{ $t('已处理') }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item :label="$t('处理描述')" prop="meterDealDescription">
                    <a-textarea v-model="formModel.meterDealDescription" :placeholder="$t('请输入处理描述')" :rows="3" style="width:100%;"/>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form-model>
    </a-spin>
    </a-modal>
</template>

<script>

  import { postAction } from '@/api/manage'
  import {netTypeObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import DetailList from '@/components/tools/DetailList'
  import {isUndefinedAndNull} from'@/utils/validate'
  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterUseWarnRecordDealModal',
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        model: {},
        netTypeObj,
        meterTypeObj,
        title: '',
        confirmLoading: false,
        disableSubmit:false,
        visible: false,
        formModel: {
            meterDealStatus: 0
        },
        url: {

          dealWarnRecord: "/jeecg-charge/meter/meterMaintenanceWarnLastRecord/updateMeterWarnRecord",
        }
      }
    },
    computed: {
      // i18n：校验消息使用 computed 以响应语言切换
      rules() {
        return {
          meterDealStatus: [
              {required:true, message:this.$t('请选择处理状态')}
          ],
          meterDealDescription: [
              {required:true, message:this.$t('请输入处理描述')}
          ]
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        if(this.model.meterDealStatus) {
          this.formModel.meterDealStatus = this.model.meterDealStatus;
        }
        this.disableSubmit = true;
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.formModel = this.$options.data.call(this).formModel;
        this.disableSubmit = false;
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.formModal.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = this.url.dealWarnRecord;
            let params = {...this.formModel}
            if(!!this.model.meterIdList) {
                // 批量处理
                params.idList = this.model.meterIdList
            }else {
                // 单个处理
                params.meterId = this.model.meterId
            }
            params.meterWarnType = 3;
            if(this.formModel.meterDealStatus == 0) {
              params.meterDealDescription0 = params.meterDealDescription
            }else if(this.formModel.meterDealStatus == 1) {
              params.meterDealDescription1 = params.meterDealDescription
            }else if(this.formModel.meterDealStatus == 2) {
              params.meterDealDescription2 = params.meterDealDescription
            }
            postAction(httpurl,params).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })

          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>
<style scoped>
.detail-list >>> .term{
  line-height: 22px;
}
</style>